function setCookie(name, value, expirationDate) {
    let expires = "";

    if (expirationDate) {
        expires = "; expires=" + expirationDate.toGMTString();
    }

    document.cookie = name + "=" + value + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length,c.length);
        }
    }

    return null;
}

function getExpirationDate() {
    let expiringDate = new Date();
    expiringDate.setHours(29);
    expiringDate.setMinutes(0);
    expiringDate.setSeconds(0);

    return expiringDate;
}

const COOKIE_NAME = 'ANONYMOUS_SESSION_R';

import appConfig from "../../app.config";
let {ANONYMOUS_SESSION_LIMIT} = appConfig;

export function getAnonymousSession() {
    let value = getCookie(COOKIE_NAME);
    if (value === null) {
        return null;
    } else {
        return parseInt(value) || 0;
    }
}

function storeAnonymousSession(value) {
    let sessionData = typeof value !== 'undefined' ? value : ANONYMOUS_SESSION_LIMIT;

    setCookie(COOKIE_NAME, sessionData, getExpirationDate());

    return sessionData;
}

export default function AnonymousSession() {
    this.UPDATE_INTERVAL = 5;

    this.onExpire = () => {};

    this.updateSessionData = function() {
        this.remaining = this.remaining - this.UPDATE_INTERVAL;
        storeAnonymousSession(this.remaining);

        if (this.remaining <= 0) {
            this.onExpire();
            this.stop();
        }
    };
    this.updateSessionData = this.updateSessionData.bind(this);

    this.remaining = getAnonymousSession();

    if (this.remaining === null) {
        this.remaining = storeAnonymousSession();
    }

    //if (this.remaining <= 0) {
    //    onExpire();
    //}

    this.start = function(onExpire) {
        this.onExpire = onExpire;
        this.intervalHandle = setInterval(this.updateSessionData, this.UPDATE_INTERVAL * 1000);
    };
    this.start = this.start.bind(this);

    this.stop = function() {
        this.intervalHandle && clearInterval(this.intervalHandle);
    };
    this.stop = this.stop.bind(this);

}


// WEBPACK FOOTER //
// ./src/anonymousSession/index.js